import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";

import ErrorBoundary from "@Components/ErrorBoundary";

const BaiduHomeDesktop = loadable(() => import("./BaiduHomeDesktop"), {
  fallback: <FullPageLoader />,
});

export default (): JSX.Element => (
  <ErrorBoundary>
    <BaiduHomeDesktop />
  </ErrorBoundary>
);
